module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_6005.3d287c5a.png";